export default __webpack_public_path__ + "geo.fb4143c3b29094e4941e87d37f235581.svg";